var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.42 43.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#00322e;}.h{fill:#fff;filter:url(#b);}.i{filter:url(#e);}"), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "f",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "f",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M30.61,37.95c-8.05,0-13.26-4.01-13.6-10.46l-.09-1.83,3.12-.44-2.38-.41L23.63,5.87h23.29l-1.86,10.6h-3.86c2.45,1.81,3.86,4.85,3.86,8.72,0,7.87-5.53,12.76-14.44,12.76Zm-.6-11.84c0,1.28,.37,1.28,.76,1.28,.52,0,1.12,0,1.12-1.48,0-.88-.21-.88-.64-.88-.56,0-.92,.16-1.24,.54v.54Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M43.37,14.47h-12.2l-1.28,3.84c1.28-1.04,2.96-1.68,5.24-1.68,4.52,0,7.92,2.92,7.92,8.56,0,6.8-4.8,10.76-12.44,10.76-6.88,0-11.32-3.12-11.6-8.56l9-1.28c0,1.88,.8,3.28,2.76,3.28s3.12-1.32,3.12-3.48c0-1.96-1.08-2.88-2.64-2.88-1.28,0-2.28,.52-3,1.56l-8-1.36,4.84-15.36h19.44l-1.16,6.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg51);
export default __webpack_public_path__ + "static/media/5_1.89ac3a432740dc31871c22e469f6841f.svg";
export { ForwardRef as ReactComponent };